import { Button, Chip } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ActionsMenu from 'utils/ActionsMenuDatagrid';
import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';
import CurrencyFormatter from 'utils/helpers/CurrencyFormatter';

export const useTransactionsMercadoPagoHook = ({
  mercadoPagoAction,
  listMercadoPago,
  cleanMercadoPagoAction,
  detailMercadoPagoAction,
  cleanDetailMercadoPagoAction,
  detailTransactionsMercadoPago,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  reportTransactionsFraud,
  actionReportTransactionsChargeback,
  reportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const { payload } = listMercadoPago || {};
  const { response } = detailTransactionsMercadoPago || {};
  const { rows, pagination } = payload || {};

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [titleDialogMessage, setTitleDialogMessage] = useState('');
  const [isDialogOpenDetails, setIsDialogOpenDetails] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [action, setAction] = useState(null);
  const [openActionFraud, setOpenActionFraud] = useState(false);
  const [descriptionTransaction, setDescriptionTransaction] = useState('');
  const [loadingFraudAndChargeback, setLoadingFraudAndChargeback] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  const [error, setError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [IdOrder, setIDorder] = useState('');
  const [mappedRows, setMappedRows] = useState([]);

  useEffect(() => {
    if (transactionId) {
      // setLoading(true);
      setIsDialogOpenDetails(true);
      detailMercadoPagoAction(transactionId);
    }
  }, [transactionId, detailMercadoPagoAction, setIsDialogOpenDetails]);

  useEffect(() => {
    if (response?.response?.status > 200) {
      setIsDialogOpenDetails(true);
      setDialogMessage('Error');
      setDialogMessage(response?.response?.data?.detail);
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      mercadoPagoAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    return () => {
      cleanMercadoPagoAction();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, mercadoPagoAction, cleanMercadoPagoAction]);

  useEffect(() => {
    // Verificar si searchParams tiene algún valor
    if (Object.keys(searchParams).length !== 0) {
      setLoading(true);
      mercadoPagoAction(page, size, searchParams)
        .then(() => setLoading(false))
        .catch(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, size]);

  useEffect(() => {
    if (listMercadoPago?.status === 200) {
      setLoading(false);
    } else if (listMercadoPago?.payload?.response?.status > 200) {
      setTitleDialogMessage(listMercadoPago?.payload?.response?.data?.title || 'Error');
      setDialogMessage(
        listMercadoPago?.payload?.response?.data?.detail ||
          'Ha ocurrido un error al cargar las transacciones.',
      );
      setIsDialogOpen(true);
      setLoading(false);
    }
  }, [listMercadoPago]);

  const onSubmit = (data) => {
    setMappedRows([]);
    const {
      from_date,
      to_date,
      mercadopago_payment_id,
      external_reference,
      card_last_digits,
      email,
      amount,
    } = data;

    const areDatesProvided = from_date !== '' && to_date !== '';
    const hasAnyFilter =
      mercadopago_payment_id !== '' ||
      external_reference !== '' ||
      card_last_digits !== '' ||
      email !== '' ||
      amount !== '';

    if (areDatesProvided || hasAnyFilter) {
      setLoading(true);
      const filteredData = Object.fromEntries(
        // eslint-disable-next-line no-unused-vars
        Object.entries(data).filter(([_, value]) => value !== ''),
      );
      setSearchParams(filteredData);
      setErrorMessage('');
      // Actualiza la URL con los filtros
      const params = new URLSearchParams(filteredData).toString();
      window.history.replaceState(null, '', `?${params}`);
    } else {
      setLoading(false);
      setErrorMessage(
        'Por favor, proporcione al menos un rango de fechas, número de operación, referencia, tarjeta, correo o monto.',
      );
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const initialFilters = {};
    params.forEach((value, key) => {
      initialFilters[key] = value;
    });
    if (Object.keys(initialFilters).length > 0) {
      setSearchParams(initialFilters);
      setLoading(true);
      mercadoPagoAction(page, size, initialFilters)
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
    Object.entries(initialFilters).forEach(([key, value]) => {
      setValue(key, value);
    });
  }, [mercadoPagoAction, page, size, setValue]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleChangePageSize = (newSize) => {
    setSize(newSize);
    setPage(1);
  };

  useEffect(() => {
    if (rows) {
      const updatedRows = rows.map((row) => ({
        ...row,
        id: `${row.id}`,
      }));
      setMappedRows(updatedRows);
    }
  }, [rows]);

  const handleIdButtonClick = (id) => {
    setIDorder(id);
    if (id) {
      setIsDialogOpenDetails(true);
      detailMercadoPagoAction(id)
        .then(() => setLoading(false))
        .catch(() => {
          setDialogMessage('Error');
          setDialogMessage('Error al cargar los detalles de la transferencia.');
          setIsDialogOpen(true);
          setLoading(false);
        });

      return () => {
        cleanDetailMercadoPagoAction();
      };
    }
  };

  const handleClose = () => {
    setIsDialogOpen(false);
    setIsDialogOpenDetails(false);
    cleanDetailMercadoPagoAction();
    if (transactionId) {
      onClose();
    }
  };

  const getStatusColor = (paymentStatus) => {
    switch (paymentStatus) {
      case 'Success':
      case 'paid':
        return 'green';
      case 'Fail':
        return 'red';
      case 'Pending':
      case 'payment_required':
        return 'Orange';
      case 'closed':
        return 'black';
      case 'opened':
        return 'gray';
      default:
        return 'purple';
    }
  };

  const translationMap = {
    Requested: 'Transacción registrada',
    Success: 'Transacción exitosa',
    Fail: 'Falló al procesar el pago',
    Pending: 'En espera de revisión',
    Error: 'Error al procesar el pago',
    paid: 'Pagado',
    payment_required: 'Pago requerido',
    closed: 'Orden cerrada',
    opened: 'Orden abierta',
  };

  const handleFraudPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'mercadopago',
    };
    actionReportTransactionsFraud({ ...payload });
  };

  const handleChargebackPrevention = (data) => {
    setLoadingFraudAndChargeback(true);
    const payload = {
      txn_payment_id: data,
      descriptionTransaction,
      payment_provider_name: 'mercadopago',
    };
    actionReportTransactionsChargeback({ ...payload });
  };

  const handleCloseFraudChargeback = () => {
    setOpenActionFraud(false);
    setDescriptionTransaction('');
    setError(false);
    setDialogMessage('');

    if (action === 'fraud') {
      cleanReportTransactionsFraud();
    } else if (action === 'chargeback') {
      cleanReportPrepaidChargebackDetails();
    }

    setLoading(true);

    mercadoPagoAction(page, size, searchParams)
      .then(() => setLoading(false))

      .catch(() => {
        setLoading(false);
      });
  };

  const handleOpenPopUp = (action, rowId) => {
    setAction(action);
    setSelectedRowId(rowId);
    setOpenActionFraud(true);
  };

  const handleConfirm = () => {
    if (descriptionTransaction === '') {
      setError(true);
    } else {
      setError(false);
      if (action === 'fraud') {
        handleFraudPrevention(selectedRowId);
      } else if (action === 'chargeback') {
        handleChargebackPrevention(selectedRowId);
      }
    }
  };

  useEffect(() => {
    if (reportTransactionsChargeback?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailMercadoPagoAction(IdOrder);
    } else if (reportTransactionsChargeback?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsChargeback?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsChargeback]);

  useEffect(() => {
    if (reportTransactionsFraud?.status === 200) {
      setDialogMessage('La operación se completó con éxito.');
      setIsError(false);
      setLoadingFraudAndChargeback(false);
      detailMercadoPagoAction(IdOrder);
    } else if (reportTransactionsFraud?.payload?.response?.status > 200) {
      setLoadingFraudAndChargeback(false);
      setDialogMessage(
        reportTransactionsFraud?.payload?.response?.data?.detail || 'Ha ocurrido un error.',
      );
      setIsError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportTransactionsFraud]);

  const Columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 180,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Button
          variant='outlined'
          onClick={() => handleIdButtonClick(params.row.id)}
          sx={{
            '&:hover': {
              color: 'white',
            },
          }}
        >
          {'Ver detalle'}
        </Button>
      ),
    },

    {
      field: 'created',
      headerName: 'Fecha DB',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return convertToMexicoTime(params);
      },
    },
    {
      field: 'mercadopago_order_status',
      headerName: 'Estado de orden',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Chip
          label={
            translationMap[params.row.mercadopago_order_status] ||
            params.row.mercadopago_order_status
          }
          style={{
            backgroundColor: getStatusColor(params.row.mercadopago_order_status),
            color: 'white',
          }}
        />
      ),
    },
    {
      field: 'merchant_order_id',
      headerName: 'ID Mercadopago',
      width: 210,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'payment_source',
      headerName: 'Medio de pago',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return params === ''
          ? '-'
          : params === 'credit_card'
            ? 'Tarjeta de crédito'
            : params === 'account_money'
              ? 'Dinero en cuenta'
              : params === 'multiple_payments'
                ? 'Pago combinado'
                : params === 'debit_card'
                  ? 'Tarjeta de débito'
                  : params;
      },
    },
    {
      field: 'masked_card',
      headerName: 'Tarjeta',
      width: 200,
      align: 'center',
      headerAlign: 'center',
      valueGetter: (params) => {
        return params === '' ? 'S/N' : params;
      },
    },
    {
      field: 'total_amount',
      headerName: 'Monto',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => <CurrencyFormatter amount={params.value} />,
    },
    {
      field: 'actions',
      headerName: 'Acciones',
      width: 200,
      headerAlign: 'center',
      renderCell: (params) => (
        <ActionsMenu
          onFraud={() => handleOpenPopUp('fraud', params.id)}
          onChargeback={() => handleOpenPopUp('chargeback', params.id)}
        />
      ),
    },
  ];

  return {
    register,
    handleSubmit,
    errors,
    onSubmit,
    loading,
    page,
    size,
    handleChangePage,
    pagination: {
      ...pagination,
      handleChangePage,
      handleChangePageSize,
    },
    rows,
    mappedRows,
    Columns,
    isDialogOpen,
    setIsDialogOpen,
    dialogMessage,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    setErrorMessage,
    handleConfirm,
    handleCloseFraudChargeback,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    loadingFraudAndChargeback,
    error,
    isError,
    handleOpenPopUp,
    setLoading,
    titleDialogMessage,
  };
};
